export default "__VITE_ASSET__4le5L$i1__"